import React, { useState, useRef, useEffect } from "react";
import { FaPaperclip, FaPaperPlane } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { HiDotsHorizontal } from "react-icons/hi";
import { IoIosCall, IoIosVideocam } from "react-icons/io";

import img1 from "../../assets/img/user/user1.png";
import img2 from "../../assets/img/user/user2.png";

const Chatroom = () => {
  const [messages, setMessages] = useState([
    {
      text: "Hi Mike! How are you",
      user: "Mark Adam",
      time: "3:00 PM",
      img: img1,
    },
    {
      text: "I am fine! What's up?",
      user: "You",
      time: "3:10 PM",
      img: img2,
    },
    {
      text: "We need to discuss about the sketchy mobile app UI design",
      user: "Mark Adam",
      time: "3:30 PM",
      img: img1,
    },
  ]);
  const [inputMessage, setInputMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const sidebarRef = useRef(null);

  const handleSendMessage = () => {
    if (inputMessage.trim()) {
      const newMessage = {
        text: inputMessage,
        user: "You",
        time: new Date().toLocaleTimeString(),
        img: "https://via.placeholder.com/40/0000FF/808080",
      };
      setMessages([...messages, newMessage]);
      setInputMessage("");
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSendFile = () => {
    if (selectedFile) {
      const fileMessage = {
        text: `${selectedFile.name} uploaded.`,
        user: "You",
        time: new Date().toLocaleTimeString(),
        img: "https://via.placeholder.com/40/0000FF/808080",
      };
      setMessages([...messages, fileMessage]);
      setSelectedFile(null);
    }
  };

  const handleToggleSidebar = () => {
    setIsVisible((prev) => !prev);
  };

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="chatroom-container mt-3">
      <div
        ref={sidebarRef}
        className={`sidebar ${isVisible ? "active" : ""}`}
      >
        <h3>Channels</h3>
        <ul className="message_user_list">
          <li># Main</li>
          <li># Real Estate</li>
          <li># Business Acquisition</li>
          <li># Combine Funding</li>
        </ul>
        <h3>Direct Messages</h3>
        <ul className="message_user_list">
          <li className="user_list">
            <img src={img2} alt="" className="user-image" />{" "}
            <div className="user">
              <div className="user_tab">
                <p>Mark Adam</p>
                <span>3:00 PM</span>
              </div>
              <p className="short_message">Lorem ipsum dolor sit amet</p>
            </div>
          </li>
        </ul>
      </div>
      <div className="chat-section">
        <div className="chat-header">
          <div className="items">
            <img src={img2} alt="" className="user-image" /> <p>Mark Adam</p>
          </div>
          <div className="items">
            <IoIosCall className="icons" />
            <IoIosVideocam className="icons" />
            <HiDotsHorizontal className="icons" />
            <button className="chat_toggle icons" onClick={handleToggleSidebar}>
            <FiMenu />
          </button>
          </div>
        </div>
        <div className="chat-messages">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`message-container ${
                message.user === "You" ? "message-right" : "message-left"
              }`}
            >
              {message.user !== "You" && (
                <img
                  src={message.img}
                  alt={message.user}
                  className="user-image"
                />
              )}
              <div
                className={`message-box ${
                  message.user === "You" ? "your-message" : "other-message"
                }`}
              >
                <div>{message.text}</div>
              </div>

              {message.user === "You" && (
                <img
                  src={message.img}
                  alt={message.user}
                  className="user-image"
                />
              )}
            </div>
          ))}
        </div>
        <div className="chat-input">
          <input
            type="text"
            placeholder="Type a message..."
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            className="input-field"
          />
          <label htmlFor="file-upload">
            <FaPaperclip className="icon" />
            <input
              id="file-upload"
              type="file"
              className="file-input"
              onChange={handleFileUpload}
            />
          </label>
          <button onClick={handleSendMessage} className="send-button">
            <FaPaperPlane />
          </button>
          {selectedFile && (
            <button onClick={handleSendFile} className="send-button">
              Send {selectedFile.name}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Chatroom;
